import React from 'react';

import { Route, Switch } from "react-router-dom";
import Group from 'components/grouppage/Group';
import GrouProjectInfo from 'components/grouppage/groupdtail/GrouProjectInfo'
export default function GroupDetailLayout({match}) {
	return (
		<>
			<Switch>
				<Route path="/group/:group_no/project/:project_no" component={GrouProjectInfo} />
				<Route path="/group/:group_no" component={Group}/>
			</Switch>
		</>
	);
}

